import { render, staticRenderFns } from "./fpgtj.vue?vue&type=template&id=38ed35f6&scoped=true"
import script from "./fpgtj.vue?vue&type=script&lang=js"
export * from "./fpgtj.vue?vue&type=script&lang=js"
import style0 from "./fpgtj.vue?vue&type=style&index=0&id=38ed35f6&prod&lang=scss"
import style1 from "./fpgtj.vue?vue&type=style&index=1&id=38ed35f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed35f6",
  null
  
)

export default component.exports